import EventEmitter from 'events';
// import View from './js/views/int-vue-productpool';
let Vue = require('../server/dev/lib/vue/dist/vue.js');
// let Vue = require('../server/dev/lib/vue/dist/vue.common.prod.js');
import {Carousel, Slide} from '../server/dev/lib/vue-carousel';
import VueRouter from '../server/dev/lib/vue-router/dist/vue-router.min.js';
Vue.use(VueRouter);
import './scss/int-vue-productpool.scss';
const $ = require('jquery');
const _ = require('lodash');
import IntersectionObserver from "@core/util/intersection-observer"


export default class Component extends EventEmitter {
  constructor(el, options) {
    super(); // calls EventEmitter's constructor
    this.utag_data = typeof utag_data !== "undefined" ? utag_data : {};
    this.utag_data.page_name = this.utag_data ? this.utag_data.page_name : $('#soasta_pageinfo').find('type').text().split('/')[1];

    // if (window.navigator.userAgent.indexOf('iPhone') > -1) {
    //   $('.productgrid').addClass('iphone')
    // }
    // if (window.navigator.userAgent.indexOf('iPad') > -1) {
    //   $('.productgrid').addClass('ipad')
    // }

    if(!!window.MSInputMethodContext && !!document.documentMode) {
      (function () {
        if (window.CustomEvent) return false;
        function CustomEvent(event, params) {
          params = params || {
              bubbles: false, cancelable: false, detail: undefined
            };
          var evt = document.createEvent( 'CustomEvent' );
          evt.initCustomEvent(
            event, params.bubbles, params.cancelable, params.detail
          );
          return evt;
        }
        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent;
      })();
    }
  }

  imgcarouselopt(router) {
    return {
      name: "imgcarousel",
      router: router,
      props: ['p', 'facetopen'],
      "components": {
        Slide,
        Carousel,
      },
      data: function() {
        let typeofimg = 'jpeg';
        if (window.webP) {
          typeofimg = 'webp';
        }
        if (window.jp2) {
          typeofimg = 'jpeg2000';
        }
        return {
          swatch: this.$props.p.product.imagery,
          jumboswatch: this.$props.p.product.swatchImage,
          autoplay: false,
          webp: typeofimg,
          load: false || window.location.pathname.indexOf('hot-toy-list') > -1,
        }
      },
      watch: {
        $route(to, from) {

        },
        p: function () {
          // console.log('product changed');
          this.swatch = this.$props.p.product.imagery;
          this.jumboswatch = this.$props.p.product.swatchImage;
        },
        "facetopen": function() {
          // console.log('change facetopen', this.$props.facetopen, this.$refs);
          setTimeout(this.toggle,500);
        }
      },
      mounted: function(){
        this.$on('colorchange', this.colorchange);
        if (!this.load) {
          this.$parent.$on('scrolled', () => {
            // console.log(this.$el)
            if (this.$el.parentElement.getBoundingClientRect().top < window.innerHeight*2) {
              this.load = true;
            }
          });
        }
      },
      template: `
<div class="productgrid-imagewrap" v-on:mouseover="triggerscroll" v-on:mouseleave="disablescroll">
    <template v-if="swatch.additionalImageSource">
        <template v-for="(img,i) in swatch.additionalImageSource">
          <template v-if="img.showJumboSwatch">
              <template v-if="jumboswatch">
                <span class="jumboswatch">
                    <img v-bind="{src:'https://slimages.macysassets.com/is/image/MCY/products/'+jumboswatch.filePath+'?$browse$&wid=50&hei=50&fmt=jpeg'}"/>
                </span>   
              </template>                       
          </template> 
          </template>
    </template>
    <carousel v-bind="{
      ref: 'carousel',
      perPage: 1,
      paginationEnabled: false,
      navigationEnabled:false,
      autoplay: autoplay,
      autoplayHoverPause: false,
      loop: true,
      speed:250,
      autoplayTimeout:1000,     
   }" v-if="load">
    <template v-if="swatch.additionalImageSource">
        <template v-for="(img,i) in swatch.additionalImageSource">
          <slide>
              <img v-bind="{src:'https://slimages.macysassets.com/is/image/MCY/products/'+img.filePath+'?$browse$&wid=450&hei=550&fmt='+webp+'&bgc=250,250,250&op_sharpen=1&layer=1&bgcolor=100,100,100&opac=5&qlt=61'}"/>                             
          </slide>            
    </template>
    </template>
    <template v-else>
        <slide>
              <img v-bind="{src:'https://slimages.macysassets.com/is/image/MCY/products/'+p.product.imagery.primaryImage.filePath+'?$browse$&wid=450&hei=550&fmt='+webp+'&bgc=250,250,250&op_sharpen=1&layer=1&bgcolor=100,100,100&opac=5&qlt=61'}"/>
          </slide>
    </template>                                
  </carousel>      
</div>
  
`,
      methods: {
        colorchange: function(e){
          console.log('component colro change', e, e.swatch.imagery, this);
          this.swatch = e.swatch.imagery;
          this.jumboswatch = e.swatch.swatchImage;
        },
        toggle: function(){
          // console.log(this.$refs, '---this.$refs');
          try {
              if (this.$props.facetopen) {
                  $(this.$refs['carousel'].$refs['VueCarousel-inner']).css({'transition': 'flex-basis 0.15s ease 0s, transform 0.5s ease 0s'});
              } else {
                  $(this.$refs['carousel'].$refs['VueCarousel-inner']).css({'transition': 'flex-basis 0.15s ease 0s, transform 0.5s ease 0.01s'});
              }
          } catch (e){}
        },
        triggerscroll: function(){
          // console.log('triggerscroll');
          this.autoplay = true;
        },
        disablescroll: function(){
          this.autoplay = false;
          try {
            this.$refs.carousel.goToPage(0);
          } catch(e){}
        },
      },
    };
  }

  ratingsopt(router) {
    return {
      name: "ratings",
      router: router,
      props: ['p'],
      "components": {
      },
      data: function() {
        return {
          productrating: ""
        }
      },
      watch: {
        $route(to, from) {

        },
        p: function(){
          try {
            this.productrating = 'width:' + ((this.$props.p.product.detail.reviewStatistics.aggregate.rating / 5) * 100) + '%;';
          } catch(e){
              this.productrating = 'width:0%';
          };
        }
      },
      mounted: function(){
        try {
          this.productrating = 'width:' + ((this.$props.p.product.detail.reviewStatistics.aggregate.rating / 5) * 100) + '%;';
        } catch(e){
            this.productrating = 'width:0%';
        }
      },
      template: `
      <div class="ratings" v-if="p.product">        
        <template v-if="p.product.detail.reviewStatistics.aggregate">
            <template v-if="typeof p.product.detail.reviewStatistics.aggregate.rating !== 'undefined'">
              <div class="ratings-background">
                  <div v-bind:style="productrating"
                  class="ratings-fill"
                  ></div> 
              </div>
              <span>({{p.product.detail.reviewStatistics.aggregate.count}})</span>                
            </template>
            <template v-else>
                <!--No ratings-->
            </template>
        </template>
        <template v-else>
            <!--No ratings-->
        </template>
      </div>  
  `,
      methods: {

      },
    }
  }

  priceopt(router) {
    return {
      name: "price",
      router: router,
      props: ['p'],
      "components": {
      },
      data: function() {
        return {
        }
      },
      watch: {
        $route(to, from) {

        }
      },
      mounted: function(){
      },
      template: `
     
      <div class="price" v-bind:class="ptypeclass(p.product)">
        <template v-if="p.product.pricing">
            <template v-if="p.product.pricing.price.priceType.text">
                <div class="pricetype-b">{{p.product.pricing.price.priceType.text}}</div>
            </template>
            <template v-if="p.product.pricing.price.priceTypeId == 24">
                <div class="valuewrap">
                    <template v-for="(price,i) in p.product.pricing.price.tieredPrice">                                    
                         <template v-if="price.label.indexOf('Sale') > -1 || price.label.indexOf('Now') > -1 || price.label.indexOf('Only') > -1 ">
                              <div v-bind:class="{badgep: _.filter(p.product.pricing.badges, function(o){ return o.finalPrice }).length > 0 }">
                                  <span class="price-sale" v-html="pricewithlabel(price.label, price.values)"></span>
                              </div>                
                          </template>
                          <template v-else>                        
                              <div v-bind="{length: p.product.pricing.price.tieredPrice.length, pricetype: p.product.pricing.price.priceTypeId, class: price.values[0].type}">
                                  <span class="price-reg" v-bind:class="price.values[0].type" v-html="pricewithlabel(price.label, price.values, 'value')"></span>
                              </div>                                               
                          </template>
                  </template>
                </div>
            </template>
            <template v-else>
                <template v-for="(price,i) in p.product.pricing.price.tieredPrice">                                    
                       <template v-if="price.label.indexOf('Sale') > -1 || price.label.indexOf('Now') > -1 || price.label.indexOf('Only') > -1 ">
                            <div v-bind:class="{badgep: _.filter(p.product.pricing.badges, function(o){ return o.finalPrice }).length > 0 }">
                                <span class="price-sale" v-html="pricewithlabel(price.label, price.values)"></span>
                            </div>                
                        </template>
                        <template v-else>                        
                            <div v-bind="{length: p.product.pricing.price.tieredPrice.length, pricetype: p.product.pricing.price.priceTypeId, class: price.values[0].type}">
                                <span class="price-reg" v-bind:class="price.values[0].type" v-html="pricewithlabel(price.label, price.values)"></span>
                            </div>                                               
                        </template>
                </template>
            </template>
            
           
            <div v-if="p.product.pricing.badges" class="badge-wrap" v-bind:data-length="p.product.pricing.badges.length">
            <template v-for="(badge,i) in p.product.pricing.badges">                                    
                   <div v-bind:class="badgeclass(badge.header)" v-if="badge.header">
                          <span v-if="badge.header.toLowerCase().indexOf('free gift') > -1" class="free">
                            Free Gift
                          </span>
                          <span v-else>
                            {{badge.header}}
                          </span>                        
                        <div class="badge-tip">
                            <div class="badge-title">{{badge.header}}</div>
                            <div>{{badge.description}}</div>
                        </div>
                   </div>
                   <div class="badge final" v-if="badge.finalPrice">
                        <span class="price-sale" v-html="pricewithlabel(badge.finalPrice.label, badge.finalPrice.values)"></span>
                   </div>
            </template>
            </div>
                        
        </template>        
      </div>  
  `,
      methods: {
        ptypeclass: function(prod){
          if (prod.pricing) {
            var cl = ""
            if (prod.pricing.price.priceTypeId) {
              cl += 'ptype-'+prod.pricing.price.priceTypeId
            }
            if (prod.pricing.price.tieredPrice) {
                var val = prod.pricing.price.tieredPrice.map(function (o) {
                    return o.label
                }).filter(function (o) {
                    return o.indexOf('value') > -1
                });
                if (val.length > 0) {
                  cl += ' ptype-value ptype-value'+prod.pricing.price.tieredPrice.map(function (o) {
                          return o.label
                      }).length
                }
            }
            // if (JSON.stringify(prod.pricing.price.tieredPrice).indexOf('A ') > -1 && JSON.stringify(prod.pricing.price.tieredPrice).indexOf(' Value') > -1) {
            //   cl += " ptype-value"
            // }
            return cl;
          } else {
            return ""
          }
        },
        badgeclass: function(label){
          if (label.toLowerCase().indexOf('code') == -1) {
            return 'badge badgemargin';
          } else {
            return 'badge'
          }
        },
        pricewithlabel: function(label, prices, value) {
          if(label.toLowerCase().indexOf(' value') > -1) {
              if (value) {
                  return "<span>(" + label.replace("A ", "") + ")</span>";
              } else {
                  return "<span>(" + label.replace("A ", "") + ")</span>";
                  // return "<span class='valueprice'>"+label+"</span>";
              }
          } else {
              let price = "";
              prices.forEach((o, i)=>{
                  if (i > 0) {
                  price += ' - ' + o.formattedValue;
              } else {
                  price += o.formattedValue
              }
          });
              return label.replace("[PRICE]", `<span>${price}</span>`);
          }

        }
      },
    }
  }
  priceopt2(router) {
        return {
            name: "price2",
            router: router,
            props: ['p'],
            "components": {
            },
            data: function() {
                return {
                }
            },
            watch: {
                $route(to, from) {

                }
            },
            mounted: function(){
            },
            template: `
     
      <div class="price" v-bind:class="ptypeclass(p.product)">
          <div class="product-price" 
          v-bind:class="{
            sale: p.product.pricing.price.priceType.onSale || p.product.pricing.price.priceType.onSale,
            notfinal: _.filter(p.product.pricing.badges, function(o){ return o.finalPrice }).length > 0,
            masterProduct: p.product.detail.flags.masterProduct 
          }">
            <div class="priceType">
                {{p.product.pricing.price.priceType.text}}
            </div>
            
            
                <template v-for="(price,i) in p.product.pricing.price.tieredPrice">                                    
                         <template v-if="price.label.indexOf('Sale') > -1 || price.label.indexOf('Now') > -1 || price.label.indexOf('Only') > -1 ">
                              <div v-bind:label="price.label">
                                    <template v-if="price.values">
                                        <template v-if="price.values[0]">
                                            <span v-html="price.values[0].formattedValue"></span>
                                        </template>
                                        <template v-if="price.values[1]">
                                            - <span v-html="price.values[1].formattedValue"></span>
                                        </template>
                                    </template>
                              </div>
                          </template>
                          <template v-else>                        
                              <template v-if="price.values">  
                                  <div v-bind="{length: p.product.pricing.price.tieredPrice.length, pricetype: p.product.pricing.price.priceTypeId, class: price.values[0].type}">
                                      <span class="price-reg" v-bind:class="price.values[0].type" v-html="pricewithlabel(price.label, price.values, 'value')"></span>
                                  </div>                        
                             </template>
                          </template>
                </template>
                
                <template v-if="p.product.pricing.badges">
                    <div v-bind:class="{
                        badges: true,
                        masterProduct: p.product.detail.flags.masterProduct
                    }">
                        <template v-for="(badge, i) in p.product.pricing.badges">
                            <template v-if="badge.finalPrice">
                                <template v-if="badge.finalPrice.values">
                                    <span v-bind:class="badge.type" class="final">    
                                        <span v-html="pricewithlabel(badge.finalPrice.label,badge.finalPrice.values)"></span>                                       
                                    </span>
                                </template>
                            </template>
                            <template v-else>
                                <div 
                                v-bind:class="[ badge.type, badge.secondBadgeWithFinalPrice ? 'secondBadgeWithFinalPrice' : '']">
                                    <span v-html="badge.header"></span>
                                </div>
                            </template>
                        </template>
                    </div>
                </template>
             
          </div>       
      </div>  
  `,
            methods: {
                ptypeclass: function(prod){
                    if (prod.pricing) {
                        var cl = ""
                        if (prod.pricing.price.priceTypeId) {
                            cl += 'ptype-'+prod.pricing.price.priceTypeId
                        }
                        if (prod.pricing.price.tieredPrice) {
                            var val = prod.pricing.price.tieredPrice.map(function (o) {
                                return o.label
                            }).filter(function (o) {
                                return o.indexOf('value') > -1
                            });
                            if (val.length > 0) {
                                cl += ' ptype-value ptype-value'+prod.pricing.price.tieredPrice.map(function (o) {
                                        return o.label
                                    }).length
                            }
                        }
                        // if (JSON.stringify(prod.pricing.price.tieredPrice).indexOf('A ') > -1 && JSON.stringify(prod.pricing.price.tieredPrice).indexOf(' Value') > -1) {
                        //   cl += " ptype-value"
                        // }
                        return cl;
                    } else {
                        return ""
                    }
                },
                badgeclass: function(label){
                    if (label.toLowerCase().indexOf('code') == -1) {
                        return 'badge badgemargin';
                    } else {
                        return 'badge'
                    }
                },
                pricewithlabel: function(label, prices, value) {
                    if(label.toLowerCase().indexOf(' value') > -1) {
                        if (value) {
                            return "<span>(" + label.replace("A ", "") + ")</span>";
                        } else {
                            return "<span>(" + label.replace("A ", "") + ")</span>";
                            // return "<span class='valueprice'>"+label+"</span>";
                        }
                    } else {
                        let price = "";
                        prices.forEach((o, i)=>{
                            if (i > 0) {
                                price += ' - ' + o.formattedValue;
                            } else {
                                price += o.formattedValue
                            }
                        });
                        return label.replace("[PRICE]", `<span>${price}</span>`);
                    }

                }
            },
        }
}

  colorsopt(router) {
    return {
      name: "colors",
      router: router,
      props: ['items'],
      "components": {
      },
      data: function() {
        return {
          original: 123,
          selectedColor: "",
          offset: 4,
          load: false || window.location.pathname.indexOf('hot-toy-list') > -1
        }
      },
      watch: {
        $route(to, from) {

        }
      },
      mounted: async function(){
        if (!this.load) {
          this.$parent.$on('scrolled', () => {
            // console.log(this.$el)
            if (this.$el.parentElement.getBoundingClientRect().top < window.innerHeight*2) {
              this.load = true;
            }
          });
        }
        // console.log('colros mounted', this, this.$el.parentElement.getBoundingClientRect().top < window.innerHeight/2)

      },
      template: `
      <div class="colors" v-if="load">
        <div class="color-swatches">
            <template v-if="items.product.traits.colors.colorMap">
                <template v-if="items.product.traits.colors.selectedColor">
                <template v-for="(color,i) in items.product.traits.colors.colorMap">
    
                      <template v-if="color.id == items.product.traits.colors.selectedColor.id">
                          <div data-first
                          v-bind:class="{'color-swatch': true, selected: color.id == selectedColor || color.id == items.product.traits.colors.selectedColor.id }"
                          v-bind="{style: {'background-image': bgurl(color.swatchImage.filePath, color)}, 'colorid': color.id, 'colorname': color.normalName ? color.normalName : 'Multi'}"
                          v-on:click.stop="selectSwatch(color, items.product.id)"
                          v-on:mouseenter="selectSwatch(color, items.product.id)"
                          >
                          </div>
                      </template>
    
                </template>
                <template v-for="(color,i) in items.product.traits.colors.colorMap">
                        <template v-if="color.id !== items.product.traits.colors.selectedColor.id">
                          <div data-notfirst
                          v-bind:class="{'color-swatch': true, selected: color.id == selectedColor }"
                          v-if="i < offset"
                          v-bind="{style: {'background-image': bgurl(color.swatchImage.filePath, color)}, 'colorid': color.id, 'colorname': color.normalName ? color.normalName : 'Multi'}"
                          v-on:click.stop="selectSwatch(color, items.product.id)"
                          v-on:mouseenter="selectSwatch(color, items.product.id)"
                          >
                          </div>
                     </template>
                    </template>
                </template>
                <template v-else>
                    <template v-for="(color,i) in items.product.traits.colors.colorMap">
                            <div
                            v-if="i < offset"
                            v-bind:class="{'color-swatch': true, selected: color.id == selectedColor }"
                            v-bind="{style: {'background-image': bgurl(color.swatchImage.filePath, color)}, 'colorid': color.id, 'colorname': color.normalName ? color.normalName : 'Multi'}"
                            v-on:click.stop="selectSwatch(color, items.product.id)"
                            v-on:mouseenter="selectSwatch(color, items.product.id)"
                            >
                            </div>
                    </template>
                </template>
    
                <template v-if="items.product.traits.colors.colorMap.length > 4">
                    <template v-if="items.product.traits.totalNumOfColors">
                        <div class="more-than-5-colors">+{{items.product.traits.totalNumOfColors - 4}}</div>
                    </template>
                    <template v-else>
                    <div class="more-than-5-colors">+{{items.product.traits.colors.colorMap.length - 4}}</div>
                </template>
            </template>
            </template>
        </div>
      </div>  
  `,
      methods: {
          bgurl: function(file, color){ 
            return 'url(//slimages.macysassets.com/is/image/MCY/products/'+file+'?fmt=jpeg&wid=30)'; 
          },

          selectSwatch: function(color, id){
          console.log('select new color', {swatch:color, id: id});
          this.$parent.$emit('colorchange', {swatch:color, id: id});
        }
      }
    }
  }


  // fo(facets){
  //   if (facets) {
  //     return facets
  //   } else {
  //     return [{"facets": {"facets": []}}]
  //   }
  // }

  facetobj() {
    console.log(arguments, this, 'facetobj');
    if (this.$props.facets) {
      return this.$props.facets
    } else {
      return [{"facets": {"facets": []}}]
    }
  }

  facetsopt(p, self) {
    // console.log('facetsopt', {p: p, "self":self})
    return {
      name: "facets",
      props: ['facets'],
      "components": {
      },
      data: function() {
        // console.log(this.$props.facets);
        try {
          return {
            facetobj: this.$props.facets,
              brandsearch: null,
              range: []
          }
        } catch(e){

          // for karma tests

          // console.log(e, this);
          return {
            facetobj: [{"facets": {"facets": []}}]
          }
        }
      },
      watch: {
        $route(to, from) {

        },
        facets: function(){
          // console.log('facets updated');
          if (this.facetobj) {
            this.facetobj = this.$props.facets;



              if($('[data-customfacet]').length > 0) {
                  this.customfacet();
              }
          }


        }
      },
      mounted: function(){
        if($('[data-customfacet]').length > 0) {
            this.customfacet();
        }

      },
      template: `
      <div class="productgrid-facets-listing">                       
          <ul>
            <template v-for="(facet,i) in facetobj[0].facets.facets">
                <template v-if=" facet.name == 'UPC_BOPS_PURCHASABLE'">
                   <li class="facet" data-bops v-bind="{class: {open: facet.collapsed, facetcustom: facet.custom, hide: true}, ref: 'facet-'+facet.name}">
                      <div accordion="toggle" v-bind="{class: {togglefacet: facet.collapsed}}" v-on:click.stop="togglefacet">Shipping and Pickup</div>
                      <div accordion="content" v-bind:data-facettype="facet.name" 
                            class="content-wrapper"
                            v-bind="{class: {show: facet.collapsed}}"
                        >
                         <ul class="list-items-container">
                           
                            <template v-for="(value,i) in facetobj[0].facets.facets.filter(function(o){ return o.name == 'UPC_SDD_PURCHASABLE'})">
                              <li class="filter-selected" 
                              :data-selecttype="value.value"
                               :data-customfacettype="value.displayName"
                              v-if="value.type === 'link'">
                                <a v-bind:href="decode_url(value.url)" v-html="value.displayName"></a>
                              </li>         
                              <li class="filter-selected" 
                                :data-selecttype="value.value" 
                                v-bind:n="facet.name" 
                                v-bind:v="value.url"  
                                v-bind="{ref: 'ffn-'+facet.name+'-'+value.value}"
                                v-on:click.stop="selectfacet.bind(this)(value.url,facet.name)"
                                v-else
                                > 
                                  <span class="checkbox" v-bind="{
                                      class: {
                                          'selected': selectedff.bind(this)(value.value, facet.name)
                                      }
                                  }"></span>
                                  <template v-if="value.displayName.indexOf(', ') > -1">
                                    <span class="display-name chunk1">{{value.displayName.split(', ')[0]}}</span>
                                    <span class="display-name chunk2">{{value.displayName.split(', ')[1]}}</span>
                                  </template>                                            
                                  <template v-else>
                                    <span class="display-name chunk1">
                                      Next-Day Delivery to <span id="sddpickup"></span>
                                    </span>
                                  </template>                                            
                              </li>
                            </template>
                            
                            <template v-for="(value,i) in facet.values">
                              <li class="filter-selected" 
                              :data-selecttype="value.value"
                               :data-customfacettype="value.displayName"
                              v-if="value.type === 'link'">
                                <a v-bind:href="decode_url(value.url)" v-html="value.displayName"></a>
                              </li>                              
                              
                              <li class="filter-selected" 
                                :data-selecttype="value.value" 
                                v-bind:n="facet.name" 
                                v-bind:v="value.url"  
                                v-bind="{ref: 'ffn-'+facet.name+'-'+value.value}"
                                v-on:click.stop="selectfacet.bind(this)(value.url,facet.name)"
                                v-else
                                > 
                                  <span class="checkbox" v-bind="{
                                      class: {
                                          'selected': selectedff.bind(this)(value.value, facet.name)
                                      }
                                  }"></span>
                                  <template v-if="value.displayName.indexOf(', ') > -1">
                                    <span class="display-name chunk1">{{value.displayName.split(', ')[0]}}</span>
                                    <span class="display-name chunk2">{{value.displayName.split(', ')[1]}}</span>
                                  </template>                                            
                                  <template v-else>
                                    <span class="display-name chunk1">
                                      Pick up at <span id="storenamebops"></span>
                                    </span>
                                  </template>                                            
                              </li>
                            </template>
                        </ul>
                      </div>
                   </li>
                </template>
                
                <!-- regular filters -->
                <template v-if=" facet.name != 'UPC_BOPS_PURCHASABLE'">
                                       
                    <li class="facet" v-bind="{class: {open: !facet.collapsed, facetcustom: facet.custom}, ref: 'facet-'+facet.name}">                      
                        <div accordion="toggle" v-bind="{class: {togglefacet: !facet.collapsed}}" v-on:click.stop="togglefacet">{{facet.displayName}}</div>
                        <div accordion="content" v-bind:data-facettype="facet.name" 
                            class="content-wrapper"
                            v-bind="{class: {show: !facet.collapsed, hide: facet.collapsed}}"
                        >
                            <ul class="list-items-container">     
                                <template v-if="facet.name == 'BRAND'">
                                  <li class="custombrand">
                                    <div>
                                      <span></span>
                                      <input placeholder="Search by Brand" name="custombrand-search" v-on:blur="changebrand($event)"/>
                                      <span v-on:click="clearbrand($event)"></span>
                                    </div>
                                  </li>
                                </template>
                                <template v-for="(value,i) in facet.values">  
                                
                                    <li class="filter-selected" 
                                    :data-selecttype="value.value"
                                     :data-customfacettype="value.displayName"
                                    v-if="value.type === 'link'">
                                      <a v-bind:href="decode_url(value.url)" v-html="value.displayName"></a>
                                    </li>
                                    
                                    <template v-if="facet.name == 'PRICE' && i == facet.values.length-1">
                                       <li class="filter-selected range"
                                        v-if="range[0] && range[1]"                                      
                                        v-bind:n="facet.name" 
                                        v-bind:or="value.value"
                                        v-bind:v="replacevalues(value.url,value.value)"
                                        @clickrange="selectfacet.bind(this)(replacevalues(value.url,value.value,value.url.indexOf(range[0]+'%257C'+range[1]) > -1),facet.name)"
                                        v-on:click.stop="selectfacet.bind(this)(replacevalues(value.url,value.value,value.url.indexOf(range[0]+'%257C'+range[1]) > -1),facet.name)"
                                        v-bind="{ref: 'ffn-'+facet.name+'-'+range[0]+'|'+range[1], 'data-selecttype': range[0]+'|'+range[1]}"
                                        > 
                                          <span>
                                              <span class="checkbox" v-bind="{
                                                class: {
                                                    'selected': value.url.indexOf(range[0]+'%257C'+range[1]) > -1
                                                }
                                            }"></span>
                                              <span class="display-name">Custom: \${{range[0]}} - \${{range[1]}}</span>
                                            </span>
                                        </li>
                                    </template>
                                    
                                    <li 
                                    v-bind:brand="!!brandsearch ? value.value.indexOf(brandsearch) == -1 : false"
                                    :data-selecttype="value.value"
                                    v-bind:n="facet.name" 
                                    v-bind:v="value.url"  
                                    v-bind="{ref: 'ffn-'+facet.name+'-'+value.value, class:{'filter-selected': true, 'hide': !!brandsearch && facet.name == 'BRAND' ? value.value.toLowerCase().indexOf(brandsearch.toLowerCase()) == -1 : false }}"
                                    v-on:click.stop="selectfacet.bind(this)(value.url,facet.name)"
                                    v-else
                                    > 
                                       <span v-if="facet.name !== 'UPC_SDD_PURCHASABLE' && facet.name !== 'UPC_BOPS_PURCHASABLE'">                                            
                                            <span class="checkbox" v-bind="{
                                                class: {
                                                    'selected': selectedff.bind(this)(value.value, facet.name)
                                                }
                                            }"></span>
                                            <template v-if="value.displayName.indexOf(', ') > -1">
                                              <span class="display-name chunk1">{{value.displayName.split(', ')[0]}}</span>
                                              <span class="display-name chunk2">{{value.displayName.split(', ')[1]}}</span>
                                            </template>                                            
                                            <template v-else>
                                              <span class="display-name chunk1">{{value.displayName}}</span>
                                            </template>                                            
                                            <span class="display-count" v-if="value.count">({{value.count}})</span>
                                        </span>
                                    </li>
                                </template>
                                
                                <template v-if="facet.name == 'PRICE'">
                                     <li class="customprice">
                                        <div>Custom Price Range</div>
                                        <div class="customprice-pricerange">
                                          <span class="input">
                                            <label for="minprice">Min</label>
                                            <input name="minprice" class="minprice" type="number" min="0"/>
                                          </span>
                                          <span>  to  </span>
                                          <span class="input">
                                            <label for="maxprice">Max</label>
                                            <input name="minprice" class="maxprice" type="number"/>
                                          </span>
                                          <span>
                                            <button v-on:click="customprice($event)">Go</button>
                                          </span>
                                        </div>
                                     </li>
                                </template>
                                
                                
                                <template v-if="facet.children">
                                    
                                    <label v-if="facet.name == 'SIZE_TYPE'" data-type="SIZE_TYPE">Size Type</label>
                                    <select v-on:change="togglenest2">
                                      <template v-for="(nested, j) in facet.children">
                                        <option v-bind:value="nested.name">
                                          {{nested.displayName}}
                                        </option>
                                      </template>
                                    </select>
                                    <template v-for="(nested, j) in facet.children">
                                        <div accordion="toggle" v-bind="{class: {}}" v-on:click="togglenest">{{nested.displayName}}</div>
                                        <div accordion="content" v-bind:data-facettype="nested.name" 
                                            class="content-wrapper" v-bind="{class: {hide: j != 0}}">
                                            <ul v-bind="{class: nested.children ? 'ul-container' : 'list-items-container-nested'}">
                                                <template v-for="(nestedval, k) in nested.values">
                                                    <li class="filter-selected" 
                                                      v-bind:n="nested.name"
                                                      v-bind:v="nestedval.url"  
                                                      v-bind="{ref: 'ffn-'+nested.name+'-'+nestedval.value}"                                                                         :data-selecttype="nestedval.value" 
                                                      v-on:click.stop="selectfacet.bind(this)(nestedval.url, nestedval.name)">
                                                      <span class="checkbox" v-bind="{ class: { 'selected': selectedff.bind(this)(nestedval.displayName, nested.name)  } }"></span>
                                                      
                                                      <template v-if="nestedval.displayName.indexOf(', ') > -1">
                                                        <span class="display-name chunk1">{{nestedval.displayName.split(', ')[0]}}</span>
                                                        <span class="display-name chunk2">{{nestedval.displayName.split(', ')[1]}}</span>
                                                      </template>                                            
                                                      <template v-else>
                                                        <span class="display-name chunk1">{{nestedval.displayName}}</span>
                                                      </template>                
                                                      
                                                      <span class="display-count " v-if="nestedval.count">({{nestedval.count}})</span>
                                                    </li>
                                                </template>
                                                <template v-for="(nestedval, k) in nested.children">
                                                  <li class="filter-selected">
                                                    <!--<div accordion="toggle" v-bind="{class: {}}" v-on:click="togglenest">{{nestedval.displayName}}</div>-->
                                                    <div class="content-label">{{nestedval.displayName}}</div>
                                                    <div accordion="content" v-bind:data-facettype="nestedval.name" 
                                            class="content-wrapper">
                                                    <ul class="list-items-container-nested">
                                                    <template v-for="(nestedval2, k) in nestedval.values">
                                                      <li class="filter-selected" 
                                                      v-bind:n="nestedval.name"
                                                      v-bind:v="nestedval2.url"  
                                                      v-bind="{ref: 'ffn-'+nestedval.name+'-'+nestedval2.value}"                                                                         :data-selecttype="nestedval2.value" 
                                                      v-on:click.stop="selectfacet.bind(this)(nestedval2.url, nestedval.name)">
                                                          <span class="checkbox" v-bind="{ class: { 'selected': selectedff.bind(this)(nestedval2.displayName, nested.name)  } }"></span>
                                                          
                                                          <template v-if="nestedval2.displayName.indexOf(', ') > -1">
                                                            <span class="display-name chunk1">{{nestedval2.displayName.split(', ')[0]}}</span>
                                                            <span class="display-name chunk2">{{nestedval2.displayName.split(', ')[1]}}</span>
                                                          </template>                                            
                                                          <template v-else>
                                                            <span class="display-name chunk1">{{nestedval2.displayName}}</span>
                                                          </template> 
                                                          
                                                          <span class="display-count" v-if="nestedval2.count">({{nestedval2.count}})</span>
                                                      </li>
                                                    </template>
                                                    </ul>
                                                    </div>
                                                    </li>
                                                </template> 
                                                
                                            </ul>
                                        </div>                                              
                                    </template>
                                </template>                                
                            </ul>
                        </div>                        
                    </li>                    
                </template>
            </template>   
          </ul>
      </div>  
      `,
      methods: {
        replacevalues: function(url,p, selected) {
          // console.log(p,'vale', url, encodeURIComponent(p), encodeURIComponent(encodeURIComponent(p)));
            console.log('replacevalue', selected, typeof selected);
          // if ()
          if(!selected) {
              return url.replace(encodeURIComponent(encodeURIComponent(p)), encodeURIComponent(encodeURIComponent(this.range[0] + '|' + this.range[1])));
          } else {
              return url.replace(encodeURIComponent(encodeURIComponent(this.range[0] + '|' + this.range[1])), '').replace(encodeURIComponent(encodeURIComponent(p)), '');
          }
        },
        customprice: function(e) {
            var min = $(e.target).closest('.customprice-pricerange').find('.minprice').val();
            var max = $(e.target).closest('.customprice-pricerange').find('.maxprice').val();
            this.range = [min, max];
            setTimeout(function(){
              $('.range').click();
            },400)
            // var name = 'ffn-PRICE-' + min + "|" + max;
            /*console.log('ccusomt', this.$refs)
            if (this.$refs['ffn-PRICE-' + min + "|" + max]) {
                this.$refs['ffn-PRICE-' + min + "|" + max].$emit('clickrange');
            }*/
        },
        clearbrand: function(e){
            this.brandsearch = null;
            $(e.target).siblings('input').val('');
        },
        changebrand: function(e){
          console.log('filter brands')
            if (e.target.value) {
                this.brandsearch = e.target.value;
            } else {
              this.brandsearch = null;
            }
        },

        decode_url:function(url){
          // console.log(url,'000000url----', unescape(url).replace(/&amp;/g,'&'));
          return url.replace(/&amp;/g,'&');
        },
        customfacet: function(){
          try {
              var custdata = JSON.parse($('[data-customfacet]').html());
              // console.log(custdata.posoti)
              var customfacet = {
                  "name": custdata.name,
                  "displayName": custdata.name,
                  "values": [],
                  "facetType": "MULTISELECTDEFAULT",
                  "collapsed": custdata.collapsed,
                  "custom": custdata.custom
              };
              custdata.items.forEach(function (o, i) {
                  customfacet.values.push({
                      "displayName": o.name,
                      "url": o.url,
                      "value": o.name,
                      "type": o.type
                  })
              });
              this.facetobj[0].facets.facets.splice(custdata.position, 0, customfacet);
          } catch(e){}
        },
        togglenest2: function(e){
            var type = e.target.value;
            console.log('toggle', e, type, $(e.target).siblings('[data-facettype="'+type+'"]').first());
            $(e.target).siblings('[data-facettype]').addClass('hide');
            $(e.target).siblings('[data-facettype="'+type+'"]').first().toggleClass('hide');
            // $(e.target).next('.content-wrapper').toggleClass('hide');
        },
        togglenest: function (e){
          $(e.target).toggleClass('togglefacet');
          $(e.target).next('.content-wrapper').toggleClass('hide');
        },
        selectedff: function(v, f){
          // console.log(this.facetobj[0].facets, v);
          if (this.facetobj[0].facets.meta.selectedFacets) {
            // console.log(this.facetobj[0].facets.meta.selectedFacets[0], v, f);
            // return false;
            // if ()
            if (this.facetobj[0].facets.meta.selectedFacets[f]) {
              return this.facetobj[0].facets.meta.selectedFacets[f].filter((o) => {
                  return o == v
                }).length > 0;
            } else {
              return false;
            }
          } else {
            return false
          }
        },
        selectfacet: function(a, b){
          console.log('select facet', a, b, this);
          let pathname = this.$parent.pool.match(/pathname=\S{1,}\?id=\d{4,}(\/\S{1,}\/\S{1,}){0,}/g);
          try {
              let cat = pathname[0].match(/id=\d{4,}/g)[0].split('id=')[1];
              let facets = [null, null];
              if (a) {
                  if (this.$parent.pool.match(/pathname=\S{1,}\?id=\d{4,}(\/\S{1,}\/\S{1,}){1,}/g)) {
                      facets = pathname[0].split(cat)[1].split('/');
                      this.$parent.pool = this.$parent.pool.split('page?id=')[0] + "page?id=" + cat + "&" + pathname[0].split(cat)[0] + cat + a;
                  } else {
                      this.$parent.pool = this.$parent.pool + a;
                  }
              } else {
                  console.log('no facet', this.$parent.pool, pathname[0].split(cat)[0]);
                  this.$parent.pool = this.$parent.pool.split('page?id=')[0] + "page?id=" + cat + "&" + pathname[0].split(cat)[0] + cat
              }
              console.log('select facet', a, b, this, pathname, this.$parent.pool, cat, facets);
          } catch(e){
              console.log(e);
          }
        },
        included: function(){},
        togglefacet: function(e){
          // console.log('togglefacet',e, this);
          $(e.target).toggleClass('togglefacet')
          // $(e.target).find('[accordion="toggle"]').toggleClass('togglefacet')
          $(e.target).siblings('[accordion="content"]').toggleClass('hide');
        }
      },
      // watch: {
      //   range: function(){
      //     console.log('range update');
      //       // $('.range').click();
      //   }
      // }
    };
  }

  loadpool(e) {
    // console.log('load new pool', e);
    e.preventDefault();
    if (!window.productgrids) {
      window.productgrids = [];
    }
    window.productgrids.forEach((o,i)=>{
      o.$emit('loadpool', e);
    })
  }

  triggeresize() {
    if (!window.productgrids) {
      window.productgrids = [];
    }
    window.productgrids.forEach((o,i)=>{
      o.$emit('windowwidth');
    })
  }
  // windowwidth(o,i) {
  //   o.$emit('windowwidth');
  // }


  init() {
    window.productevents = {}
    $(document).on({click: this.loadpool},'.pool-link')
    $(window).on('resize', this.triggeresize);
    console.log('init', this)
    let routes = [];
    const router = new VueRouter({
      mode: 'history',
      routes // short for `routes: routes`
    })

    window.productgrids = [];
    let pg = $('.productgrid[data-pool]');


    // scrolling image carousel

    // const imgcarousel = this.imgcarousel()
    const imgcarousel = Vue.component('imgcarousel', this.imgcarouselopt(router));

    // ratings
    const ratings = Vue.component('ratings', this.ratingsopt(router));

    // price
    const price = Vue.component('price', this.priceopt(router));

    const price2 = Vue.component('price2', this.priceopt2(router));

    // colors
    const colors = Vue.component('price', this.colorsopt(router));


    // facets
    const facets = Vue.component('facets', this.facetsopt(router));


    $.each(pg, (i, el)=>{
      let g = new Vue(this.mainopt.bind(this)(el, router, {
            Slide,
            Carousel,
            imgcarousel: imgcarousel,
            ratings: ratings,
            price: price,
            facets: facets,
            colors: colors
          }
        ));
      window.productgrids = window.productgrids.concat([g]);
    });
    //   this.setupmain.bind(this, arguments, router, {
    //     Slide,
    //     Carousel,
    //     imgcarousel: imgcarousel,
    //     ratings: ratings,
    //     price: price,
    //     facets: facets
    //   })
    // )
  }

  setupmain(router, components) {
    let g = new Vue( this.mainopt.bind(this)(arguments[4], router, components) );
    // productgrids = productgrids.concat([g]);
  }


  mainopt(el, router, components) {
    return {
      "el": el,
      "name": "productgrid",
      "router": router,
      "components": components,
      "data": function(){
        let removed = [];
        // console.log('$(el)', $(el).data('remove'));
        try {
          if (typeof $(el).data('remove')[0].ids != 'undefined') {
            removed = $(el).data('remove').map((o) => {
              return o.ids
            });
          }else{
            removed = JSON.parse($(el).data('remove')).map((o) => {
              return o.ids
            });
          }
        } catch(e){
          // console.log('-------eee', e)
        }
        return {
          "adobetag": window.utag_data || {},
          "utag_data": window.utag_data || {},
          "title": $(el).data('title') || "",
          "remove": removed,
          "selectedFacetUrl": "",
          "windowwidth": $(window).width() > 1024,
          "pool": this.$route.query.pool ? this.$route.query.pool : $(el).data('pool'),
          "styles": "",
          "currentPage": this.$route.query.currentPage ? this.$route.query.currentPage : 1,
          "collection": [],
          "facetswidth": $(window).width() > 1024 ? "376px" : '0px',
          "facetopen": $(window).width() > 1024,
          "facetcopy": $(window).width() > 1024 ? "Filter by" : "show filter",
          // "lid": document.cookie.indexOf('ishop_app') > -1 ? "" : "",
          "model": {
            "meta": {
              "itemCount": 0,
            },
            "sort": [],
            pagination: {
              "numberOfPages": 1000,
            }
          },
          "productsPerPage": this.$route.query.productsPerPage ? this.$route.query.productsPerPage : 120,
          "sort": this.$route.query.sort ? this.$route.query.sort : "ORIGINAL",
          "quickview": $(el).data('quickview'),
          "facets": [],
          "carouseloptions": {
            perPage: 1,
            paginationEnabled: false,
            navigationEnabled:false,
            autoplay: false,
            autoplayHoverPause: false,
            loop: true,
            speed:250,
            autoplayTimeout:1000,
          },
          firstload: true,
          adobetime: "",
          adobep: [],
          autotag: $(el).data('autotag')
        }
      },
      "template":
        `<div class="productgrid"">            
            <h3 class="productgrid-h3">{{title}} <span>({{model.meta.itemCount}})</span></h3>
            <!--<h4>{{model.meta.itemCount}} items</h4>-->
            <div class="productgrid-subnav mobile-only">                
              <div class="togglefacets">
                  <div class="toggler" v-on:click="togglefacets">
                    <span class="desktop-only">{{facetcopy}}</span>
                    <div class="filters-mobile-scroller">
                        <div class="filters-mobile-wrap">
                            <span class="mobile-only filters-first">Filters</span>
                            <template v-if="facets[0]">
                                <template v-for="(facet,i) in facets[0].facets.facets">
                                    <span class="mobile-only other" v-on:click="selectfacetmobile" v-bind:data-catdn="facet.displayName" v-bind:data-catn="facet.name" v-html="facet.displayName"></span>
                                </template>
                            </template>
                        </div>
                    </div>
                  </div>
                  <div class="productgrid-sorter">
                      <div class="sortlabel">Sort by </div>
                      <select v-on:change="togglesort">
                          <template v-for="(s,i) in model.sort">
                              <option v-bind:value="s.value" v-bind="{selected: s.value == sort }">{{s.name}}</option>
                          </template>
                      </select>
                  </div>
                <div class="clearall" v-if="facets.length > 0" v-on:click="clearall" v-bind="{class: {'hide': facetcopy !== 'Filter by'}}">Clear All</div></div>
                </div>
            
            <div class="productgrid-wrapper">
              
                <div class="productgrid-facets" v-bind="{style: {width: facetswidth}}" v-bind:state="facetcopy">
                    <div class="productgrid-subnav">
                        <div class="mobile-tablet-only">
                            <div class="mobile-tablet-only-title">Sort & Filter</div>
                            <div class="mobile-tablet-only-buttons">
                                <div v-on:click="clearall">Clear All</div>
                                <div v-on:click="togglefacets">Apply</div>
                            </div>
                        </div>
                        <div class="productgrid-sorter">
                            <div class="sortlabel">Sort by </div>
                            <select v-on:change="togglesort">
                                <template v-for="(s,i) in model.sort">
                                    <option v-bind:value="s.value" v-bind="{selected: s.value == sort }">{{s.name}}</option>
                                </template>
                            </select>
                        </div>
                        <div class="togglefacets"><div class="toggler" v-on:click="togglefacets">
                          <span class="desktop-only">{{facetcopy}}</span>
                          <span class="mobile-only">Filter</span>
                        </div> 
                        <div class="clearall" v-if="facets.length > 0" v-on:click="clearall" v-bind="{class: {'hide': facetcopy !== 'Filter by'}}">Clear All</div></div>
                    </div>
                    <div class="mobiletablet-bg"  v-on:click="togglefacets">&nbsp;</div>
                    <div v-on:click="togglefacets" class="togglefacets mobile-only">
                      <div v-on:click="clearall" class="clear-tablet" v-if="facets.length > 0">clear all</div>
                      <div class="filters-icon"></div>
                      <img alt="close" 
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAAAyVJREFUaAXdmstqFUEQhkeNa/GGgkFHURREn8DF2bgQISBkIQgu9BV8AZ/BpbgQxCwEL+DKZ3AlgoKIg4YoBpVAVkaN/z9OhZpK97nMpafbgj/Vt+mpb6qm4ZyTLMuym9AK9AI6DqVqdxD4D+iuAKyhsVnpI3wOpWZPELAw0F8gwEszuIx+DqViTxGohmL7KIOfhz5AevJTNQ4Xrc0hsmeQjnsD/QUdsQuOsByP0aaCksAJwUzpJxAj3ExQApdHDrcL8U0sP4GxPsdAjJkj1CNIV9S2dwrzYy3HbExwLqhfiLF2UIwlUpM52i64w2pNiKYParHNzXNcbOHeYSwUXC9Q8kAI9xnStR0CrlcogTsZGC4IVGi4nbihPf14ULR6pwTC5/vOHKEeQLrse4cSWB/cQVnQ0LugfmOvXjNlY3XBvcGipnA+qGv2xiH6hPsK6bJpAhcVlDy4My3hooRqCxc1VFO4HbjwHqTLmAfFIO+UQPi8ryz3mQuSgpLYXXCvMClwLqg/mI8yUwIlnnDfIF1mhNsP2fLjmhtQMnYOkX6HNBy/89P95KDk6RPOZk7AWH5JZUqgxJ9HQ2C0vyULUvQ8KO57wF5jfO//BiWZI9yB1OBcp99tQNgDJBk4V/nxoLheZeYs/CokWaN/C0WdOUItmaA1FKZKO42/ycBNC1WxZUnAzQqVBJwP6qpEP8H7MndownW9TvMrMtc7NS2UBOeCe4/JQeAI9RjSpxsPilmhcElphPsC6f2Cw3UN9Q8ty04MCeeC4vd+TTMlUOIHgfNBXZGoOvI+uCMd7V/bJhSU3NQFV2CyU7g5bGgPCpZf15nCljXrFY5QzyF9WoWAEkLCLZv7F+i3ypwLagOb9p0p3KJmx9DrDM4Hdbl2y3CdTuBig5LH54Pj+ETbjRX2nWL5DZUpG7ALjmU6Fo5Q/Ne+TaWYoBBWaTPBuaB+YptYMlUxbTnCFZBOwrbM+aAubm0TZ4NHfgF54ZbMJBfGmimEVrN59ArIwu3hqnUzcYmDCRkzx484Gm7E+B+qwdSgGD9Nw/FdKzPGiRF0io2EjT9VjaDyk/dfbIf2lyJyaWsAAAAASUVORK5CYII=" 
                      />
                    </div>
                    <template v-if="facets.length > 0">
                        <facets v-bind="{model: model, facets: facets, ref: 'facets'}"></facets>
                    </template>
                    <div class="mobile-only clear-apply-wrapper">
                      <div class="clear-btn" v-on:click="clearall" v-if="facets.length > 0" >Clear All</div> 
                      <div class="apply-btn" v-on:click="togglefacets">Apply</div>
                    </div>
                </div>
                <div class="productgrid-products" v-bind="{style: {width: 'calc(100% - '+facetswidth+')'} }">
                    <div class="facets-that-were-selected">                
                        <template v-if="facets[0]">
                          <template v-for="(f,i) in facets[0].facets.meta.selected">
                            <template v-if="f.children">
                                <template v-for="(selecteds,k) in f.children[0].values">
                                    <div v-on:click="removefacet" v-bind:type="f.children[0].name" v-bind:value="selecteds.value" class="facets-that-were-selected_selected nested">{{selecteds.displayName}}</div>                          
                                </template>                          
                              </template>
                              <template v-else>
                                <template v-for="(selected,j) in f.values">                                                  
                                      <div v-on:click="removefacet" v-bind:type="f.name" v-bind:value="selected.value" class="facets-that-were-selected_selected">
                                        <template v-if="f.name !== 'UPC_BOPS_PURCHASABLE' && f.name !== 'UPC_SDD_PURCHASABLE' ">{{selected.displayName}}</template>
                                        <template v-if="f.name === 'UPC_BOPS_PURCHASABLE'">Pick Up</template>
                                        <template v-if="f.name === 'UPC_SDD_PURCHASABLE'">Next-day Delivery</template>
                                      </div>                          
                                </template>          
                              </template>                                
                          </template>
                        </template>                
                    </div>
                    <template v-for="(p,i) in collection">
                        <template v-if="p.product">
                        <div class="productgrid-product" v-bind:data-id="p.product.id" v-if="!!!p.product.detail.flags.siteMonetizationProduct">
                            <a v-bind="{'href': quickview ? '#' : hrefmaker(p.product.id, p.product), ref: 'product-'+p.product.id, 'data-pdpids': quickview ? p.product.id : false}" 
                            >
                                <div class="productgrid-productimage">
                                  <div v-if="quickview" class="quickview">
                                    <span>quickview</span>
                                  </div>
                                <imgcarousel v-bind="{p: p, ref: 'imgcarousel-'+p.product.id, facetopen: facetopen}"></imgcarousel>                                                   </div>            
                                <div class="productgrid-product-details info-container">
                                    <colors v-bind="{items:p}"></colors>
                                    <div class="info-inner">
                                      <div class="brand" v-html="p.product.detail.brand"></div>
                                      <div class="name" v-html="p.product.detail.name"></div>
                                      <price2 v-bind="{p: p}"></price2>
                                    </div>
                                    <!--
                                      <div class="productgrid-product-details-brand" v-html="p.product.detail.brand"></div>
                                      <div class="productgrid-product-details-name" v-html="p.product.detail.name"></div>                                    
                                      <price v-bind="{p: p}"></price>
                                    -->
                                    <ratings v-bind="{p: p}"></ratings>
                                </div>
                            </a>
                        </div>
                        </template>
                    </template>
                </div>
            </div>
            <div class="productgrid-pagination">
                <div class="productgrid-pagination-arrows">
                    <div v-on:click="pminus" v-if="currentPage > 1" class="productgrid-pagination-arrows-prev">Prev</div>
                    <div class="productgrid-pagination-select">
                        <select v-on:change="pselect">
                            <template v-for="(page,i) in new Array(model.pagination.numberOfPages).fill('')">
                                <option v-bind:value="i+1" v-bind:selected="currentPage == (i+1)">Page: {{i+1}} of {{model.pagination.numberOfPages}}</option>
                            </template>
                        </select>
                    </div>
                    <div v-on:click="padd" v-if="currentPage < model.pagination.numberOfPages" class="productgrid-pagination-arrows-next">Next</div>
                </div>
            </div>
        </div>`,
      "mounted": function () {

        console.log('mounted product grid');
        this.getPool('first mount');
        this.$on('colorchange', this.colorchange);
        this.$on('windowwidth', this.windowresized);
        this.$on('loadpool', this.loadpool);

        // lazy load
        if (window.location.pathname.indexOf('hot-toy-list') == -1) {
          this.$emit('scrolled')
          setTimeout(() => {
            this.$emit('scrolled')
          }, 1000);
          $(window).scroll(() => {
            this.$emit('scrolled')
          })
        }

        ///trigger initial load images
        $(window).scroll()



        try {

          if(typeof(Event) === 'function') {
            window.productevents.loadpool = new Event('loadpool');
            window.productevents.firstload = new Event('firstload');
          }else{
            window.productevents.loadpool = new Event('loadpool');
            window.productevents.loadpool.initEvent('loadpool', true, true);
            window.productevents.firstload = new Event('firstload');
            window.productevents.firstload.initEvent('firstload', true, true);

            // Backbone.$.
          }

          // window.productevents.loadpool = new Event('loadpool');
          // window.productevents.firstload = new Event('firstload');
        } catch(e){}

        try {
          window.productevents.triggerloadevent = (fail) => {
            setTimeout(()=>{
              try {
                if (fail == 'fail') {
                  window.productevents.loadpool.detail = {"failed": true}
                }
                document.dispatchEvent(window.productevents.loadpool)
              } catch(e){
                Backbone.$( document ).trigger( "loadpool", [fail]);
              }
            },5)
          }
          window.productevents.triggerfirstload = (fail) => {
            setTimeout(()=>{
              try {
                if (fail == 'fail') {
                  window.productevents.firstload.detail = {"failed": true }
                }
                document.dispatchEvent(window.productevents.firstload)
              } catch(e){
                Backbone.$( document ).trigger( "firstload" , [fail]);
              }
            },5)
          }
        } catch(e){}

      },
      "methods": {
        selectfacetmobile: function(e){
            console.log('selectfacetmobile', e);
            var tar = e.target.dataset['catn'];
            var t = $('[data-facettype="'+tar+'"]');
            t.siblings('[accordion="toggle"]').addClass('togglefacet');
            t.removeClass('hide')
            t.parent().addClass('open');
            t.parent().siblings('.open').removeClass('open').find('[data-facettype]').addClass('hide');
            t.parent().siblings('.open').removeClass('open').find('[accordion="toggle"]').removeClass('togglefacet');
            t[0].scrollIntoView({
                behavior: "smooth", // or "auto" or "instant"
            });
        },
        hrefmaker: function(product, data){

          if (document.cookie.indexOf('ishop_app') > -1) {
            return '/shop/product/?ID='+product;
          } else {
            if (typeof utag_data !== 'undefined') {
              if (data.identifier){
                return data.identifier.productUrl + '&lid=' + utag_data.page_name.replace(/-/g, '') + '_productgrid-' + product;
              } else {
                return '/shop/product/?ID=' + product + '&lid=' + utag_data.page_name.replace(/-/g, '') + '_productgrid-' + product;
              }
            } else {
              return '/shop/product/?ID='+product;
            }
          }
        },

        clearall: function(){
          this.pool = this.$route.query.pool ? this.$route.query.pool : $(el).data('pool');
          if (_.isArray(this.pool)) {
            this.pool = this.pool[1].replace(/page\?id=(\d{1,})\?/g, `page?id=$1&`);
          }
        },
        windowresized: function(){
            // console.log('resized windowwidth')
            this.windowwidth = $(window).width();
        },
        colorchange: function(color){
          // console.log('parent color change', color, this.$refs);
          this.$refs['imgcarousel-'+color.id].$emit('colorchange', color);
        },
        removefacet: function(e){
          // console.log('removefacet', e.target, this);
          if (e.target.classList.contains('nested')) {
            // console.log('removefacet nested', e.target, this);
            $(this.$refs['facets'].$refs["ffn-"+e.target.getAttribute('type')+'-'+e.target.getAttribute('value')]).click();

          } else {
            $(this.$refs['facets'].$refs["ffn-"+e.target.getAttribute('type')+'-'+e.target.getAttribute('value')]).click();
            // $(this.$refs['facets'].$refs["ffn-"+e.target.getAttribute('value')]).click();
          }
          // console.log(this.$refs['facets'].$refs["ffn-"+e.target.getAttribute('value')])
            // .click();
        },
        query(newQuery) {
          let extend = Object.assign({}, this.$route.query);
          let newq = Object.assign(extend, Object.assign({}, newQuery));
          for (let q in newq) {
            if (!newq[q]) {
              delete newq[q];
            }
          }
          // if(newq['c'] && newq['gender']) {
          //   delete newq['gender'];
          // }
          return newq;
        },
        togglesort: function(e){
          this.sort = e.target.value;
          // this.$router.push({'query': this.query({sort: e.target.value }) });
        },
        togglefacets: function(){
          this.facetopen = !this.facetopen;
          if (this.facetopen) {
            this.facetcopy = 'Filter by';
            if (this.windowwidth){
              // 356px
              this.facetswidth = '320px';
            } else {
              this.facetswidth = '0px';
            }
          } else {
            this.facetcopy = 'show filter';
            this.facetswidth = '0px';
          }

          // this.resetCarousels.bind(this)();
        },
        resetCarousels: function(){

        },
        // filterp: function(o,p){
        //   console.log('filterp2');
        //   return [];
        // },
        rowSortableGrid: (o) => {
          // console.log('filterp2', o);
          return o.rowSortableGrid
        },
        rowFacets: (o) => {
          return o.facets
        },
        sortableGrid: (o) => {
          return o.sortableGrid
        },
        setpdata: function(d, type){
          if (d.length > 0) {
            if (d[0].rowSortableGrid) {
              let f = _.filter(d[0].rowSortableGrid.zones, this.rowFacets);
              let s =_.filter(d[0].rowSortableGrid.zones, this.sortableGrid);

              if (s.length > 0) {
                let g = s[0].sortableGrid;
                console.log('getPool', g);
                try {
                  // move removed to the end
                  let filtered = g.collection.filter((o)=>{
                    if (o.product){
                      return this.$data.remove.indexOf(o.product.id.toString()) == -1
                    } else {
                      return o
                    }
                  });
                  let removed = g.collection.filter((o)=>{
                    if (o.product){
                      return this.$data.remove.indexOf(o.product.id.toString()) > -1
                    } else {
                      return o
                    }
                  });
                  this.$data.collection = filtered.concat(removed)
                  this.$data.model = g.model;
                } catch(e){}
              }
              if (f.length > 0) {
                this.$data.facets = f;
              }
            } else {
              try {
                let filtered = d
                  .filter((o) => {
                    if (o.product) {
                      return this.$data.remove.indexOf(o.product.id.toString()) == -1
                    } else {
                      return o
                    }
                  });
                let removed = d.filter((o)=>{
                  if (o.product){
                    return this.$data.remove.indexOf(o.product.id.toString()) > -1
                  } else {
                    return o
                  }
                });
                this.$data.collection = filtered.concat(removed)
              } catch(e){
                return [];
              }
              // this.$data.model = {};
              // this.$data.facets = {}
            }

          }
          $(this.$el).removeClass('loading');


          try {
            if (type === 'first mount') { //the first time
              window.productevents.triggerfirstload();
            } else { // on all faceting
              window.productevents.triggerloadevent();
            }
          } catch (e) {}
        },
        getPoolData: function(type, data) {
          // console.log('getpooldata', data, type)
          // if (data == 'fail') {
          //   this.setpdata.bind(this)(d, type)
          // }
          // else
          try { 
            // console.log('apppending----') 
            $('body').append(`<script data-analytics-pp><!-- ${JSON.stringify(data.meta)} --></script>`) 
          } catch(e){ 
            // console.log('err apppending', e) 
          }

          if (data.body) {
            try {
              let d = _.filter(data.body.canvas.rows, this.rowSortableGrid);
              this.setpdata.bind(this)(d, type)
              this.triggeradobetag.bind(this)(data, window.location)

            } catch (e) {
              //not a valid product pool
            }
          } else {
            let d = data;
            this.setpdata.bind(this)(d, type)
            this.triggeradobetag.bind(this)(data, window.location)
          }
        },
        triggeradobetag: function(data, loc){
          // console.log('triggeradobetag')

          // utag_data['product_id'] = meta.analytics.data.productID;
          // utag_data['product_rating'] = meta.analytics.data.productRating;
          // utag_data['product_reviews'] = meta.analytics.data.productReviews;
          // utag_data['results_current_page'] = meta.analytics.data.resultsCurrentPage;
          // utag_data['results_per_page'] = meta.analytics.data.resultsPerPage;
          // utag_data['sort_type'] = meta.analytics.data.sortType;
          // utag_data['total_results'] = meta.analytics.data.totalResults;
          // utag_data['product_placement_reason'] = meta.analytics.data.productPlacementReason;
          // utag_data['product_badge_new_markdown'] = meta.analytics.data.newMarkDownProducts;
          // utag_data['product_badge_new_arrival'] = meta.analytics.data.newArrivalProducts;
          //
          if (data.meta) {
            // console.log('triggeradobetag meta', data.meta)
            let tag = Object.assign(utag_data,{product_id: []});
            try {
               tag = Object.assign(Object.assign(utag_data, {
                product_id: data.meta.analytics.data.productID,
                product_rating: data.meta.analytics.data.productRating,
                product_reviews: data.meta.analytics.data.productReviews,
                results_current_page: data.meta.analytics.data.resultsCurrentPage,
                results_per_page: data.meta.analytics.data.resultsPerPage,
                sort_type: data.meta.analytics.data.sortType,
                total_results: data.meta.analytics.data.totalResults,
                product_placement_reason: data.meta.analytics.data.productPlacementReason,
                product_badge_new_markdown: data.meta.analytics.data.newMarkDownProducts,
                product_badge_new_arrival: data.meta.analytics.data.newArrivalProducts,
                product_pricing_state: data.meta.analytics.data.productPricingState || [],
                facet_names: data.meta.analytics.data.facetNames || [],
                facet_values: data.meta.analytics.data.facetValues || [],
                page_type: "browse",
                ebp_eligible: ((data.meta.pageType.search || data.meta.pageType.zeroSearchResults) && data.meta.pageType.giftEligibleBrowsePag),
                search_keyword: data.meta.context.searchTerm,
                search_pass: data.meta.analytics.data.searchPass,
                percent_ltr: data.meta.analytics.data.percentLtr,
                ltr_user_purchase_count: data.meta.analytics.data.ltrUserPurchaseCount,
                search_token: data.meta.analytics.data.crsSearchToken,
                apollo_product_count: data.meta.analytics.data.apolloProductCount,
                apollo_search_pass: data.meta.analytics.data.apolloSearchPass,
                category_id: data.meta.analytics.data.categoryID,
                category_name: data.meta.analytics.data.categoryName.replace("&amp;", "and").replace("&#x27;", ""),
                fob_category_id: data.meta.analytics.data.fobCategoryID,
                fob_category_name: data.meta.analytics.data.fobCategoryName,
                top_level_category_id: data.meta.analytics.data.topLevelCategoryID,
                top_level_category_name: data.meta.analytics.data.topLevelCategoryName,
              }), Object.assign(data.meta.analytics.data, {
                page_type: "browse"
              }));
            } catch(e) {
              console.log('adobe tag err', e)
               // tag = Object.assign(utag_data,{product_id: []});
            }
              // try {
              // console.log('triggeradobetag.....',tag.product_id,this.adobetag.product_id, window.utag, loc,tag, this.adobetag,data.meta.analytics.data.productID, 'te')
              // } catch(e){}

              if (loc.search.indexOf('&ids=') == -1 && loc.search.indexOf('?ids=') == -1) {
                // console.log('triggeradobetag pass1')
                if (this.adobetag && tag) {
                  // try {
                  //   console.log('triggeradobetag pass2', this.firstload, tag.product_id[0], this.adobetag.productID[0], this.adobetag.product_id[0], this.adobetime, this.adobep, tag.timestamp)
                  // } catch(e){}
                  // try {
                  //   console.log('triggeradobetag logic', window.utag && ((this.firstload) || (tag.product_id[0] !== this.adobep)))
                  //
                  // } catch(e){}
                // && tag.product_id !== this.adobetag.product_id
                  if (window.utag && ((this.firstload) || (tag.product_id[0] !== this.adobep)) && this.autotag) {
                        // console.log('triggeradobetag pass3')
                        window.utag['view'](tag);
                        console.log('triggeradobetag tag', tag)
                        this.firstload = false;
                        this.adobetag = Object.assign({},tag);
                        this.adobep =  tag.product_id[0];
                        this.adobetime = (' ' + tag.timestamp).slice(1);
                  }
                } else {

                }
              }

          }
        },
        getPool: function(type){
          // console.log('ppoll, loading', this.$el)
          $(this.$el).addClass('loading');
          console.log(this.$data.pool, 'getPool')
          if (_.isArray(this.$data.pool)) {
            this.$data.pool = this.$data.pool[1].replace(/page\?id=(\d{1,})\?/g, `page?id=$1&`);
          }
          if(window.location.href.indexOf('localhosttest') > -1 && this.$data.pool.indexOf('//www.') == -1) {
            this.$data.pool = 'https://www.macys.com'+ this.$data.pool
          }

          var sort = '&sortBy='+this.$data.sort
          if (this.$data.pool.indexOf('Sortby') > -1) {
            sort = ""
          } else {

          }

          $.ajax({
            url: this.$data.pool+'&pageIndex='+this.$data.currentPage+'&productsPerPage='+this.$data.productsPerPage+sort,
            'complete': ()=>{
              // console.log('getPool complete', type)
              // if (type == 'first mount') {
              //   window.productevents.triggerfirstload()
              // }
            }
          }).done(this.getPoolData.bind(this, type))
            .fail(function(){
              window.productevents.triggerfirstload('fail');
              // this.getPoolData.bind(this)('first mount', {})
            });
        },
        "padd": function(){
          if (this.currentPage < this.model.pagination.numberOfPages) {
            this.currentPage++;
            this.$router.push({query: this.query({
              currentPage: this.currentPage
            })})
          }
        },
        "pminus": function(){
          if (this.currentPage > 1) {
            this.currentPage--;
            this.$router.push({query: this.query({currentPage: this.currentPage})})
          }
        },
        "pselect": function(e){
            this.currentPage = e.target.value;
            this.$router.push({query: this.query({currentPage: this.currentPage})})
        },
        loadpool: function(e){
          // console.log('loadpool', e.target.dataset['pool']);
          if (this.pool) {
            this.pool = e.currentTarget.dataset['pool'];
            this.title = e.currentTarget.dataset['title'];
            this.routed = e.currentTarget.dataset['routed'];
            if (this.routed == 'true') {
                // this.$router.push({query: this.query({pool: this.pool})});
            }
          }
          // window.scrollTo(0,this.$el.offsetTop);
        },
      },
      "watch": {
        $route(to, from) {
          try {
            console.log('route pool change', this.$route.query.currentPage, this.currentPage, this.$route.query.pool, this.pool)
          } catch(e){}
          try {
            if (this.$route.query.currentPage !== this.currentPage || this.$route.query.pool !== this.pool) {
              this.getPool();
            } else {
              console.log('do not get pool, as it hasnt changed', this)
            }
          } catch(e){}
        },
        sort: function() {
          console.log('sort change')
          this.currentPage = 1;
          this.getPool();
        },
        pool: function(){
          try {
            console.log('pool change', this.$route.query.currentPage, this.currentPage, this.$route.query.pool, this.pool)
          } catch(e){}
          this.currentPage = 1;
          this.sort = "ORIGINAL";
          this.$router.push({query: this.query({
            currentPage: this.currentPage,
            // sort: this.sort
          })}).catch(()=>{});
          this.getPool();

        }
      }
    }
  }


}


// WEBPACK FOOTER //
// /Users/elizabeth.chen/Documents/Work/2/int-vue-productpool/src/int-vue-productpool.js